// extracted by mini-css-extract-plugin
export var legendIndicator = "_ds-1";
export var legendRight = "_ds-0";